import { Typography, Container } from "@mui/material";
import useIsMobileView from "../../utils/hooks/useIsMobileView";

const QuestionSlide = () => {
  const IsMobileView = useIsMobileView();
  return (
    <Container
      disableGutters
      maxWidth="lg"
      sx={{
        px: IsMobileView ? "2vw" : "10vw",
        py: "10vh",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        userSelect: "none",
      }}
    >
      <Typography variant={IsMobileView ? "h4" : "h2"} align="center" sx={styles.text}>
        Kui Teil on küsimusi, pannakse testimine pausile.
      </Typography>
      <br />
      <br />
      <br />
      <Typography variant={IsMobileView ? "h4" : "h2"} align="center" sx={styles.text}>
        Kui olete valmis, alustage testimist.
      </Typography>
    </Container>
  );
};

export default QuestionSlide;

const styles = {
  rootContainer: {
    px: "10vw",
    py: "10vh",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  text: {
    height: "fit-content",
  },
};
